import { Injectable } from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {environment} from '../environments/environment'
import { Observable } from 'rxjs';
import {dataType} from './dataType'
// import 'rxjs/add/operator/map';


@Injectable({
  providedIn: 'root'
})
export class DataService {
  serviceUrl;
  serviceUrl1;
  auth_token=JSON.parse(localStorage.getItem('token')).idToken.jwtToken
  
  constructor(private http:HttpClient) { 
     this.serviceUrl=environment.serviceUrl;
     this.serviceUrl1=environment.serviceUrl1;
  }
 
  getUsersList (): Observable<dataType> {
    // console.log(data)
    return this.http.get<dataType>(this.serviceUrl+'/getUserList',
    {
      headers: new HttpHeaders().set('Authorization',this.auth_token)
     })
  }

  getGroupList (): Observable<dataType> {
    return this.http.get<dataType>(this.serviceUrl+'/getGroupList',
    {
      headers: new HttpHeaders().set('Authorization',this.auth_token)
     })
  }

  getBucketList (): Observable<dataType> {
    return this.http.get<dataType>(this.serviceUrl+'/getBucketList',
    {
      headers: new HttpHeaders().set('Authorization',this.auth_token)
     })
  }

  addUser (data): Observable<any> {
    console.log(data)
    return this.http.post<any>(this.serviceUrl+ '/addUser', data,
    {
      headers: new HttpHeaders().set('Authorization',this.auth_token)
     });
  }
  
  addGroup (data): Observable<dataType> {
    console.log(data)
    return this.http.post<dataType>(this.serviceUrl+ '/addGroup', data,
    {
      headers: new HttpHeaders().set('Authorization',this.auth_token)
     });
  }

  addBucket (data: dataType): Observable<dataType> {
    console.log(data)
    return this.http.post<dataType>(this.serviceUrl+ '/addBucket', data,
    {
      headers: new HttpHeaders().set('Authorization',this.auth_token)
     });
  }

  deleteUser (data): Observable<dataType> {
    console.log(data)
    return this.http.post<dataType>(this.serviceUrl+ '/deleteUser', data,
    {
      headers: new HttpHeaders().set('Authorization',this.auth_token)
     });
  }

  deleteGroup (data): Observable<dataType> {
    console.log(data);
    return this.http.post<dataType>(this.serviceUrl+ '/deleteGroup', data,
    {
      headers: new HttpHeaders().set('Authorization',this.auth_token)
     });
  }

  deleteBucket (data): Observable<dataType> {
    return this.http.post<dataType>(this.serviceUrl+ '/deleteBucket', data,
    {
      headers: new HttpHeaders().set('Authorization',this.auth_token)
     });
  }

  listS3Object (data): Observable<dataType> {
    console.log(data)
    return this.http.post<dataType>(this.serviceUrl+ '/listS3Object', data,
    {
      headers: new HttpHeaders().set('Authorization',this.auth_token)
     });
  }

  getGroupRolePolicy (data): Observable<dataType> {
    return this.http.post<dataType>(this.serviceUrl+ '/getGroupRolePolicy', data,
    {
      headers: new HttpHeaders().set('Authorization',this.auth_token)
     });
  }

  deleteS3Object (data): Observable<dataType> {
    return this.http.post<dataType>(this.serviceUrl+ '/deleteS3Object', data,
    {
      headers: new HttpHeaders().set('Authorization',this.auth_token)
     });
  }

  updateUserAttribute (data): Observable<dataType> {
    console.log(data)
    return this.http.post<dataType>(this.serviceUrl+ '/updateUserAttribute', data,
    {
      headers: new HttpHeaders().set('Authorization',this.auth_token)
     });
  }

  updateGroupRolePolicy (data): Observable<dataType> {
    console.log(data)
    return this.http.post<dataType>(this.serviceUrl+ '/updateGroupRolePolicy', data,
    {
      headers: new HttpHeaders().set('Authorization',this.auth_token)
     });
  }

  getSignedUrl (data): Observable<dataType> {
    console.log(data)
    return this.http.post<dataType>(this.serviceUrl+ '/getSignedUrl', data,
    {
      headers: new HttpHeaders().set('Authorization',this.auth_token)
     });
  }

  downloadS3Object (data): Observable<dataType> {
    console.log(data)
    return this.http.post<dataType>(this.serviceUrl+ '/downloadS3Object', data,
    {
      headers: new HttpHeaders().set('Authorization',this.auth_token)
     });
  }

  uploadImage (data): Observable<any> {
    console.log(data)
    return this.http.post<any>(this.serviceUrl+ '/uploadImage', data,
    {
      headers: new HttpHeaders().set('Authorization',this.auth_token)
     });
  }

  uploads3Object (data): Observable<any> {
    console.log(data)
    return this.http.post<any>(this.serviceUrl+ '/uploads3Object', data,
    {
      headers: new HttpHeaders().set('Authorization',this.auth_token)
     });
  }

  getIamUsersList (): Observable<dataType> {
    // console.log(data)
   var data={"logout":"true"}
    return this.http.post<dataType>(this.serviceUrl1+'/listIamUser',data,
    {
      headers: new HttpHeaders().set('Authorization',this.auth_token)
     })
  }

  getIamGroupList (): Observable<dataType> {
    // console.log(data)
    return this.http.post<dataType>(this.serviceUrl1+'/listIamGroups',
    {
      headers: new HttpHeaders().set('Authorization',this.auth_token)
     })
  }

  addIamUser (data): Observable<any> {
    console.log(data)
    return this.http.post<any>(this.serviceUrl1+ '/createIamUser', data,
    {
      headers: new HttpHeaders().set('Authorization',this.auth_token)
     });
  }

  deleteIamUsers (data): Observable<any> {
    console.log(data)
    return this.http.post<any>(this.serviceUrl1+ '/deleteIamUsers', data,
    {
      headers: new HttpHeaders().set('Authorization',this.auth_token)
     });
  }

  disableUser (data): Observable<any> {
    console.log(data)
    return this.http.post<any>(this.serviceUrl+ '/disableUser', data,
    {
      headers: new HttpHeaders().set('Authorization',this.auth_token)
     });
  }

  enableUser (data): Observable<any> {
    console.log(data)
    return this.http.post<any>(this.serviceUrl+ '/enableUser', data,
    {
      headers: new HttpHeaders().set('Authorization',this.auth_token)
     });
  }
}
